import {
	type GetMyNotificationsQuery,
	type GetMyUnreadNotificationCountQuery
} from "~/gql/queries/notification.generated";

export const notificationEndpoints = {
	GetMyNotifications: {
		providesTags: ["Notifications"] as AddTagTypes,
		transformResponse: (res: GetMyNotificationsQuery) => res
	},
	GetMyUnreadNotificationCount: {
		providesTags: ["Notifications"] as AddTagTypes,
		transformResponse: (res: GetMyUnreadNotificationCountQuery) => res
	},
	MarkAllNotificationsRead: {
		invalidatesTags: ["Notifications"] as AddTagTypes
	},
	MarkNotificationRead: {
		invalidatesTags: ["Notifications"] as AddTagTypes
	},
	MarkNotificationUnread: {
		invalidatesTags: ["Notifications"] as AddTagTypes
	}
};
